import AppBar from '@mui/material/AppBar';
import styled from '@mui/system/styled';

export const HeaderWrapper = styled(AppBar)`
    display: flex;
    flex-wrap: wrap;
    background-color: #fff;
    border-bottom: 1px solid #e0e0e0;
    z-index: 5;
    user-select: none;
    padding: 0 16px;
`;

export const LogoWrapper = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 1380px;
    padding: 14px 0;
`;

export const TopHeaderWrapper = styled('div')`
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    justify-content: center;
`;

export const BottomHeaderWrapper = styled('div')`
    width: 100%;
    max-width: 1360px;
    margin: 0 auto;
    padding: 4px 0;
    color: rgba(0, 0, 0, 0.87);
    display: flex;
    justify-content: space-between;

    @media (max-width: 1420px) {
        max-width: 1196px;
    }
`;
